import React from 'react'
import { t } from '../i18n'
import { useFollow } from '../State/Follow'
import { track } from '../Utils/analytics'
import { CheckIcon, PlusIcon } from './Icons'

/* "+ Prati" / "✓ Pratiš" (spec 2, Dugmad):
   - variant="header": primary orange, then an outlined "✓ Pratiš" that unfollows
   - variant="list": secondary outlined, then plain grey "✓ Pratiš"
   kind: 'topic' ({ slug, title }), 'source' ({ slug, name }) or 'keyword' ({ title }).
   small: the compact header bar's size. */
export default function FollowButton({
  kind,
  item,
  variant = 'list',
  from,
  onFollow,
  small = false,
}) {
  const follow = useFollow()
  if (!item) return null

  let following
  let toggle
  let name
  if (kind === 'source') {
    name = item.name
    following = follow.isSourceFollowed(item.slug)
    toggle = () => {
      const now = follow.toggleSource(item.slug)
      track(now ? 'source_follow' : 'source_unfollow', { source: item.slug, from })
      if (now) onFollow?.()
    }
  } else {
    name = item.title
    const existing =
      kind === 'topic' ? follow.followedTopic(item.slug) : follow.followedKeyword(item.title)
    following = Boolean(existing)
    toggle = () => {
      if (existing) {
        follow.removeTopic(existing.key)
        track('topic_unfollow', { from })
        return
      }
      if (kind === 'topic') {
        follow.addTopic({ slug: item.slug, title: item.title })
        track('topic_follow', { topic: item.slug, from })
      } else {
        follow.addKeyword(item.title)
        track(from === 'search' ? 'search_follow' : 'custom_topic_add', { from })
      }
      onFollow?.()
    }
  }

  const label = following
    ? t(kind === 'source' ? 'follow.unfollowSource' : 'follow.unfollowTopic', { name })
    : t(kind === 'source' ? 'follow.followSource' : 'follow.followTopic', { name })

  const className = following
    ? variant === 'header'
      ? 'btn btn-secondary btn-following'
      : 'btn-plain btn-following'
    : variant === 'header'
    ? 'btn btn-primary'
    : 'btn btn-secondary'

  return (
    <button
      type="button"
      className={`${className} follow-button ${small ? 'btn-small' : ''}`}
      aria-pressed={following}
      aria-label={label}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        toggle()
      }}
    >
      {following ? (
        <CheckIcon size={16} strokeWidth={2.5} />
      ) : (
        <PlusIcon size={16} strokeWidth={2.5} />
      )}
      <span>{following ? t('follow.following') : t('follow.follow')}</span>
    </button>
  )
}
